
















import Vue from 'vue';
import { eventBus } from '@/main';
import { errorCodeFromAxiosError } from '@/models/ErrorCode';
import { AxiosError } from 'axios';
import msg from '@/services/userMsg';
import BaseModal from '@/components/BaseModal.vue';
import { user } from '@/services/api/userApi';
import { propOfType } from '@/services/utils';

export default Vue.extend({
  mounted() {
    this.getTermsAndConditions();
  },
  components: {
    BaseModal,
  },
  props: {
    onClose: propOfType<Function>((forceLogout: boolean) => {}),
  },
  computed: {
    buttonClass() {
      if (this.isAccepLoading || this.isRejectLoading) {
        return `font-semibold p-2 rounded-lg text-center text-white
          shadow-inner bg-gray-600`;
      }
      return `font-semibold p-2 rounded-lg text-center
        text-white bg-gray-900 hover:bg-gray-700`;
    },
  },
  data() {
    return {
      isAccepLoading: false,
      isRejectLoading: false,
      idCuentaCorporativa: this.$store.getters.selectedAccount.account.idCuentaSgv,
      termsAndConditionsHTML: null as string | null,
      termsAndConditionsId: null as number | null,
    };
  },

  methods: {
    getTermsAndConditions() {
      user.getTermsAndConditions(this.idCuentaCorporativa!)
        .then((response) => {
          const { data } = response;

          if (!data || !data?.html) {
            this.onClose(false);
            return;
          }
          this.termsAndConditionsId = data.id;
          this.termsAndConditionsHTML = data.html;
        })
        .catch((error: AxiosError) => {
          // eslint-disable-next-line no-console
          console.error('Error fetching terms and conditions:', error);
          this.onClose(true); // Force logout on error
        });
    },
    acceptOrRejectTerms(accepted: boolean) {
      user.acceptTermsAndConditions({
        cuentaCorporativaId: this.idCuentaCorporativa!,
        terminosCondicionesId: this.termsAndConditionsId!,
        aceptar: accepted,
        plataforma: 'INWEB',
      })
        .then(() => {
          this.onClose(!accepted); // Force logout if rejected
        })
        .catch((error: AxiosError) => {
          // eslint-disable-next-line no-console
          console.error('Error updating terms and conditions:', error);
          this.onClose(true); // Force logout on error
        });
    },
    onConfirm() {
      this.isAccepLoading = true;
      this.acceptOrRejectTerms(true);
    },
    onReject() {
      this.isRejectLoading = true;
      this.acceptOrRejectTerms(false);
    },
  },
});
